import type { ArtifactStatus, SurveyStatus, SurveyTemplateStatus, TaskStatus } from 'shared'

type BadgeTone = 'neutral' | 'default' | 'success' | 'warning'

/**
 * How each lifecycle state reads at a glance. They live together because the
 * two sides of the app show the same states and must agree on their colour:
 * a report that is amber for the operator cannot be green for the member.
 */
export const SURVEY_STATUS_TONE: Record<SurveyStatus, BadgeTone> = {
  draft: 'neutral',
  published: 'default',
  closed: 'success',
}

export const ARTIFACT_STATUS_TONE: Record<ArtifactStatus, BadgeTone> = {
  draft: 'neutral',
  published: 'success',
  archived: 'warning',
}

export const TEMPLATE_STATUS_TONE: Record<SurveyTemplateStatus, BadgeTone> = {
  draft: 'neutral',
  published: 'success',
  archived: 'warning',
}

/**
 * A report's state. `closed` is neutral rather than red: it means somebody
 * decided, not that something went wrong. Red here made every tidied-up
 * report look like an incident.
 */
export const FEEDBACK_STATUS_TONE: Record<
  'open' | 'in_progress' | 'resolved' | 'closed',
  BadgeTone
> = {
  open: 'warning',
  in_progress: 'default',
  resolved: 'success',
  closed: 'neutral',
}

export const TASK_STATUS_TONE: Record<TaskStatus, BadgeTone> = {
  draft: 'neutral',
  open: 'default',
  in_progress: 'warning',
  completed: 'success',
  cancelled: 'neutral',
}
